module.exports = __webpack_public_path__ + "img/newbgTwo.2f691eee.jpg";